const extraServicesData = [
    {
        id: 1,
        name: 'Pre-wedding day filming (3hours)',
        price: '€ 3,000'
    },

    {
        id: 2,
        name: 'Day-After Brunch filming (3hours)',
        price: '€ 3,000'
    },

    {
        id: 3,
        name: '3 Vertical Highlight videos of wedding day delivered in 2 weeks',
        price: '€ 900'
    },

    {
        id: 4,
        name: 'extra hour',
        price: '€ 400'
    },

    {
        id: 5,
        name: 'super8 Filming',
        price: '€ 1,000'
    },

    {
        id: 6,
        name: 'express editing (2 weeks)',
        price: '€ 1,500'
    },

    {
        id: 7,
        name: 'travel cost outside of Paris is not included',
        price: '0'
    },

    {
        id: 8,
        name: 'Raw materials',
        price: '€ 1,000'
    },

    {
        id: 9,
        name: 'NDA',
        price: '30% depends on Package'
    },
]

export default extraServicesData;